import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.contentTarget.classList.toggle("hidden")

    // Prevent body scroll when modal is open
    if (!this.contentTarget.classList.contains("hidden")) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
  }

  close(event) {
    event.preventDefault()
    this.contentTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  // Close on escape key
  connect() {
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleKeydown)
    document.body.style.overflow = ""
  }

  handleKeydown(event) {
    if (event.key === "Escape" && !this.contentTarget.classList.contains("hidden")) {
      this.contentTarget.classList.add("hidden")
      document.body.style.overflow = ""
    }
  }
}
